module.exports = __webpack_public_path__ + "static/mexc-logo-eb2dac8bbdf2b9146c11a929b647367d.webp";